module.exports = __webpack_public_path__ + "img/scene1-0.321cbbf8.jpg";